import TopBar from './layout/Topbar';
import React, { Suspense, useState } from 'react';
import './styles.scss';
import ProtectedRoute from './routes/ProtectedRoute';
import { Redirect, Switch } from 'react-router-dom';
import { ProgressBar } from 'primereact/progressbar';
import { isAuthenticated } from './services/auth';
import RecentCheckIn from './views/CheckIn/RecentCheckIn';
import PrimaryButton, { CustomButton } from './shared/Button/CustomButton';
// import { useSelector } from 'react-redux';
function App() {
    const [checkInVisiblity, setCheckInVisibility] = useState(false);
    return (
        <>
            {isAuthenticated() ? (
                <>
                    <TopBar />

                    <Suspense fallback={<ProgressBar mode="indeterminate" style={{ height: '3px' }} />}>
                        <div className="main-container p-2">
                            <Switch>
                                <ProtectedRoute />
                            </Switch>
                        </div>
                    </Suspense>
                    <RecentCheckIn checkInVisiblity={checkInVisiblity} setCheckInVisibility={setCheckInVisibility} />
                </>
            ) : (
                <Redirect to="/login" />
            )}
        </>
    );
}

export default App;
